import { api } from "../../lib";

export interface Source {
  id: string;
  name: string;
  description: string | null;
  collectionMethodId: string | null;
  organMapTemplateId: string | null;
  applicableProcedures: string[] | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  collectionMethod?: { id: string; name: string } | null;
  organMapTemplate?: { id: string; name: string } | null;
}

export interface CreateSourceInput {
  name: string;
  description?: string;
  collectionMethodId?: string | null;
  isActive?: boolean;
}

export interface UpdateSourceInput extends Partial<CreateSourceInput> {
  id: string;
}

export const sourcesService = {
  getAll: async () => {
    return api.get<Source[]>("/admin/sources");
  },

  getById: async (id: string) => {
    return api.get<Source>(`/admin/sources/${id}`);
  },

  create: async (input: CreateSourceInput) => {
    return api.post<Source>("/admin/sources", input);
  },

  update: async (input: UpdateSourceInput) => {
    const { id, ...updates } = input;
    return api.put<Source>(`/admin/sources/${id}`, updates);
  },

  delete: async (id: string) => {
    await api.delete<void>(`/admin/sources/${id}`);
  },

  toggleActive: async (id: string, isActive: boolean) => {
    return api.put<Source>(`/admin/sources/${id}`, { isActive });
  },
};
